import React, { useState } from 'react';
import {
  Modal,
  Form,
  Input,
  message,
  Upload,
  Radio,
  Checkbox,
} from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axios';

const { Dragger } = Upload;

const GalleryModal = ({ open, setOpen, refresh }) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('banner');

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setFile(null);
    setType('banner');
  };

  const handleFinish = async (values) => {
    if (!file || !file.originFileObj) {
      message.error("Please upload a file");
      return;
    }

    const formData = new FormData();
    formData.append("title", values.title || '');
    formData.append("link", values.link || '');
    formData.append("subtitle", values.subtitle || '');
    formData.append("publish", values.publish || false);

    // Append the correct file and flags
    switch (type) {
      case 'banner':
        formData.append("banner", file.originFileObj);
        formData.append("is_banner", true);
        break;
      case 'banner_bg':
        formData.append("banner_bg", file.originFileObj);
        formData.append("is_banner_bg", true);
        break;
      case 'image':
        formData.append("image", file.originFileObj);
        break;
      case 'video':
        formData.append("video", file.originFileObj);
        break;
    }

    setLoading(true);
    try {
      await axiosInstance.post("gallery/gallery/", formData);
      message.success("Media uploaded successfully!");
      form.resetFields();
      setFile(null);
      setOpen(false);
      refresh(`gallery/gallery/?page=${1}`);
    } catch (err) {
      console.error(err);
      message.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    multiple: false,
    beforeUpload: (file) => {
      const isImage = ['image/jpeg', 'image/png', 'image/webp', 'image/avif'].includes(file.type);
      const isVideo = file.type === 'video/mp4';
      const isValid =
        (type === 'video' && isVideo) || (type !== 'video' && isImage);
      if (!isValid) {
        message.error(type === 'video' ? 'Only MP4 allowed' : 'Only image files allowed');
        return Upload.LIST_IGNORE;
      }

      const maxSize = type === 'video' ? 20 : 10;
      if (file.size / 1024 / 1024 > maxSize) {
        message.error(`File must be smaller than ${maxSize}MB`);
        return Upload.LIST_IGNORE;
      }

      setFile({ ...file, originFileObj: file });
      return false;
    },
    onRemove: () => setFile(null),
    fileList: file ? [file] : [],
  };

  return (
    <Modal
      title="Add Media Item"
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      okButtonProps={{
        autoFocus: true,
        htmlType: 'submit',
        loading,
        disabled: loading,
      }}
      onOk={() => form.submit()}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleFinish}
      >
				<ul>
					<li>Banner Slider : 1024x820 </li>
					<li>Banner Background : 1024x820 </li>
				</ul>
        <Form.Item label="Select Type" required>
          <Radio.Group value={type} onChange={e => {
            setType(e.target.value);
            setFile(null); // Reset file on type change
          }}>
            <Radio.Button value="banner">Banner</Radio.Button>
            <Radio.Button value="banner_bg">Banner BG</Radio.Button>
            <Radio.Button value="image">Gallery Image</Radio.Button>
            <Radio.Button value="video">Gallery Video</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: 'Title is required' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Link"
          name="link"
        >
          <Input placeholder="https://getam.com"/>
        </Form.Item>

        {type === 'video' && (
          <Form.Item
            label="Subtitle"
            name="subtitle"
            rules={[{ required: true, message: 'Subtitle is required for video' }]}
          >
            <Input />
          </Form.Item>
        )}

        <Form.Item label={type === 'video' ? "Upload MP4" : "Upload Image"} required>
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag {type === 'video' ? 'video' : 'image'} to upload
            </p>
            <p className="ant-upload-hint">
              {type === 'video'
                ? 'Only MP4 — Max 20MB'
                : 'JPG, PNG, WEBP, AVIF — Max 2MB'}
            </p>
          </Dragger>
        </Form.Item>

        <Form.Item name="publish" valuePropName="checked">
          <Checkbox>Publish</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GalleryModal;
